/* Terug-naar-boven knop voor de jewels-collectie.
   Wordt alleen geladen op dat sjabloon (zie layout/theme.liquid), dus hier geen
   extra controle op het template. De knop staat niet in de Liquid maar wordt hier
   gemaakt: zo blijft het één bestand om terug te draaien. */
(function () {
  if (document.querySelector('.jw-top')) return;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'jw-top';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  document.body.appendChild(btn);

  // Verschijnt pas als je ruim een schermhoogte gescrold hebt, anders staat hij
  // meteen over de eerste rij producten heen.
  var ticking = false;
  function update() {
    ticking = false;
    btn.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.2);
  }
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );
  update();
})();
